import {IVector2} from "./SwipeController";
import {breakpoints} from "@styles/tokens";

export class SwipeOutTranstion {
  private _element:HTMLDivElement;
  private _direction:IVector2;
  private _rotation:number;
  private dragTreshold:number = 30;
  private _customDirection:string;

    public constructor(element, direction, rotation, customDirection?){
     this._element = element;
     this._direction = direction;
     this._rotation = rotation;
     this._customDirection = customDirection;
     
      this.clone()
  }

  private clone():void {

    let transitionItem = this._element.cloneNode(true) as HTMLDivElement;
    transitionItem.style.position = "absolute";
    transitionItem.style.left = `${this._direction.x}`;
    transitionItem.style.top = `${this._direction.y}`;
    transitionItem.style.display = "block !important";
    transitionItem.style.opacity = null;
    transitionItem.style.transform = `translate(-50%, -50%) rotate(${this._rotation + 'deg'})`
    transitionItem.style.transition = `all 1s ease-out`
    transitionItem.style.zIndex = `${transitionItem.style.zIndex + 100}`
    document.getElementById('itemContainer').appendChild(transitionItem);


    this.startTransition(transitionItem);
  }


    private startTransition(element:HTMLDivElement):void {
    this._element.style.opacity = "0";

    const ovarlay:HTMLDivElement = element.children[0] as HTMLDivElement;

    const svgAttending:HTMLElement = ovarlay.children[2] as HTMLElement;
    const svgLate:HTMLElement = ovarlay.children[1] as HTMLElement;
    const svgMissing:HTMLElement = ovarlay.children[0] as HTMLElement;

    let whereToTransition:string;
    if(this._customDirection){
      whereToTransition = this._customDirection;
    } else {
      whereToTransition = this.getDragDirection(this._direction);
    }

    let mobile = window.innerWidth <= breakpoints.mobile

    if(whereToTransition === 'left'){
      setTimeout(() => {
        element.style.left = `${Number(element.style.left.split('px')[0]) - (mobile?750:1500)}px`;
        element.style.transform = `translate(-50%, -50%) rotate(${this._rotation - (mobile?25:100) + 'deg'})`
        ovarlay.style.background = 'rgba(250, 80, 94, 0.4)';
        svgMissing.style.opacity = `0.7`;
      }, 1); 
      element.style.top = `${this._direction.y}`;
    } else if (whereToTransition === 'right') {
      setTimeout(() => {
        element.style.left = `${Number(element.style.left.split('px')[0]) + (mobile?750:1500)}px`;
        element.style.transform = `translate(-50%, -50%) rotate(${this._rotation + (mobile?25:100) + 'deg'})`
        ovarlay.style.background = 'rgba(42, 132, 142, 0.4)';
        svgAttending.style.opacity = `0.7`;
      }, 1); 
      element.style.top = `${this._direction.y}`;
    } else if (whereToTransition === 'up') {
      setTimeout(() => {
        element.style.top = `${Number(element.style.top.split('px')[0]) - (mobile?750:1500)}px`;
        element.style.transform = `translate(-50%, -50%) rotate(${this._rotation - (mobile?15:60) + 'deg'})`
        ovarlay.style.background = 'rgba(254, 212, 37, 0.4)';
        svgLate.style.opacity = `0.7`;
      }, 1); 
      element.style.left = `${this._direction.x}`;
      
    }

    setTimeout(() => this.onAnimationComplete(element), 1000);
  }

  private onAnimationComplete = (element):void =>   {
    element.remove();
    setTimeout(() => {
      this._element.style.opacity = "1";
      
    }, 3000);
  }

  private getDragDirection = (offset:IVector2):string => {

    const absX:number = Math.abs(offset.x);
    const absY:number = Math.abs(offset.y);

    if(absX > absY) { 
        if(absX < this.dragTreshold) {
            return '';
        }

        // dragging horizontally
        if(offset.x < 0) {
            // dragging left
            return 'left';

        } else {
            // dragging right
            return 'right';
        }
    } else if(offset.y > 0) {
        // dragging up
        if(absY < this.dragTreshold) {
            return '';
        }

        return 'up';
    } else {
        // dragging down - not supported
    }

    return '';
}
}